/**
 * Persist the pickup/drop/distance snapshot used on the fare-results screen
 * so late Places/geocode callbacks cannot blank the route summary.
 */

const createEmptyRouteSummary = () => ({
  pickup: '',
  dropoff: '',
  distance: 0,
});

/**
 * @param {{pickup:string, dropoff:string, distance:number}} current
 * @param {{pickup?:string, dropoff?:string, distance?:number}} next
 */
const commitRouteSummary = (current, next = {}) => {
  const pickup = String(next.pickup ?? current.pickup ?? '').trim();
  const dropoff = String(next.dropoff ?? current.dropoff ?? '').trim();
  const distanceNum = Number(next.distance ?? current.distance ?? 0);
  return {
    pickup,
    dropoff,
    distance: Number.isFinite(distanceNum) && distanceNum > 0 ? distanceNum : 0,
  };
};

const routeSummaryIsComplete = (summary) =>
  Boolean(summary?.pickup && summary?.dropoff && Number(summary?.distance) > 0);

module.exports = {
  createEmptyRouteSummary,
  commitRouteSummary,
  routeSummaryIsComplete,
};
